import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { AnalyticsContext } from './AnalyticsContext';
// eslint-disable-next-line @repo/internal/react/no-class-components
export default class AnalyticsProvider extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      analytics: this.props.analytics
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(AnalyticsContext.Provider, {
      value: this.state
    }, this.props.children);
  }
}